"use strict";

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.evaluate = evaluate, exports.Evaluator = void 0;

var _ethers = require("ethers"),
    _types = _interopRequireDefault(require("../types")),
    _HelperManager = _interopRequireDefault(require("../helpers/HelperManager")),
    _defaults = require("../defaults");
/**
* @module radspec/evaluator
*/

/**
* A value coupled with a type
*
* @class TypedValue
* @param {string} type The type of the value
* @param {*} value The value
* @property {string} type
* @property {*} value
*/


var TypedValue = /*#__PURE__*/function () {
  function TypedValue(type, value) {
    _classCallCheck(this, TypedValue);

    if (this.type = type, this.value = value, _types.default.isInteger(this.type) && !_ethers.BigNumber.isBigNumber(this.value) && (this.value = _ethers.BigNumber.from(this.value)), "address" === this.type) {
      if (!_ethers.ethers.utils.isAddress(this.value)) throw new Error("Invalid address \"".concat(this.value, "\""));
      this.value = _ethers.ethers.utils.getAddress(this.value);
    }
  }
  /**
  * Get the string representation of the wrapped value
  *
  * @return {string}
  */


  _createClass(TypedValue, [{
    key: "toString",
    value: function toString() {
      return this.value.toString();
    }
  }]);

  return TypedValue;
}();
/**
* Walks an AST and evaluates each node.
*
* @class Evaluator
* @param {radspec/parser/AST} ast The AST to evaluate
* @param {radspec/Bindings} bindings An object of bindings and their values
* @param {?Object} options An options object
* @param {?Object} options.availablehelpers Available helpers
* @param {?ethers.providers.Provider} options.provider EIP 1193 provider
* @param {?string} options.to The destination address for this expression's transaction
* @property {radspec/parser/AST} ast
* @property {radspec/Bindings} bindings
*/


var Evaluator = /*#__PURE__*/function () {
  function Evaluator(ast, bindings) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$availableHelpers = _ref.availableHelpers,
        availableHelpers = _ref$availableHelpers === void 0 ? {} : _ref$availableHelpers,
        provider = _ref.provider,
        from = _ref.from,
        to = _ref.to,
        _ref$value = _ref.value,
        value = _ref$value === void 0 ? "0" : _ref$value,
        data = _ref.data;

    _classCallCheck(this, Evaluator);

    this.ast = ast, this.bindings = bindings, this.provider = provider || new _ethers.ethers.providers.WebSocketProvider(_defaults.DEFAULT_ETH_NODE), this.from = from && new TypedValue("address", from), this.to = to && new TypedValue("address", to), this.value = new TypedValue("uint", _ethers.BigNumber.from(value)), this.data = data && new TypedValue("bytes", data), this.helpers = new _HelperManager.default(availableHelpers);
  }
  /**
  * Evaluate an array of AST nodes.
  *
  * @param  {Array<radspec/parser/Node>} nodes
  * @return {Promise<Array<string>>}
  */


  _createClass(Evaluator, [{
    key: "evaluateNodes",
    value: function () {
      var _evaluateNodes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(nodes) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", Promise.all(nodes.map(this.evaluateNode.bind(this))));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function evaluateNodes(_x) {
        return _evaluateNodes.apply(this, arguments);
      }

      return evaluateNodes;
    }()
    /**
    * Evaluate a single node.
    *
    * @param  {radspec/parser/Node} node
    * @return {Promise<string>}
    */

  }, {
    key: "evaluateNode",
    value: function () {
      var _evaluateNode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(node) {
        var _Mathceil, length, left, right, _left, _right, leftValue, rightValue, bothTypesAddress, bothTypesBytes, _left2, leftFalsey, target, inputs, outputs, selectedReturnValueIndex, returnType, abi, ethersInterface, txData, data, decodeData, helperName, _inputs, result, binding;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _Mathceil = Math.ceil;

                if (!("ExpressionStatement" === node.type)) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 4;
                return this.evaluateNodes(node.body);

              case 4:
                return _context2.abrupt("return", _context2.sent.join(" "));

              case 5:
                if (!("GroupedExpression" === node.type)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", this.evaluateNode(node.body));

              case 7:
                if (!("MonologueStatement" === node.type)) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", new TypedValue("string", node.value));

              case 9:
                if (!("StringLiteral" === node.type)) {
                  _context2.next = 11;
                  break;
                }

                return _context2.abrupt("return", new TypedValue("string", node.value || ""));

              case 11:
                if (!("NumberLiteral" === node.type)) {
                  _context2.next = 13;
                  break;
                }

                return _context2.abrupt("return", new TypedValue("int256", node.value));

              case 13:
                if (!("BytesLiteral" === node.type)) {
                  _context2.next = 16;
                  break;
                }

                length = _Mathceil((node.value.length - 2) / 2);
                return _context2.abrupt("return", (32 < length && this.panic("Byte literal represents more than 32 bytes"), new TypedValue("bytes".concat(length), node.value)));

              case 16:
                if (!("BoolLiteral" === node.type)) {
                  _context2.next = 18;
                  break;
                }

                return _context2.abrupt("return", new TypedValue("bool", "true" === node.value));

              case 18:
                if (!("BinaryExpression" === node.type)) {
                  _context2.next = 37;
                  break;
                }

                _context2.next = 21;
                return this.evaluateNode(node.left);

              case 21:
                left = _context2.sent;
                _context2.next = 24;
                return this.evaluateNode(node.right);

              case 24:
                right = _context2.sent;

                if (!(("string" === left.type || "string" === right.type) && "PLUS" === node.operator)) {
                  _context2.next = 27;
                  break;
                }

                return _context2.abrupt("return", new TypedValue("string", left.value.toString() + right.value.toString()));

              case 27:
                _context2.t0 = (_types.default.isInteger(left.type) && _types.default.isInteger(right.type) || this.panic("Cannot evaluate binary expression \"".concat(node.operator, "\" for non-integer types \"").concat(left.type, "\" and \"").concat(right.type, "\"")), node.operator);
                _context2.next = _context2.t0 === "PLUS" ? 30 : _context2.t0 === "MINUS" ? 31 : _context2.t0 === "STAR" ? 32 : _context2.t0 === "POWER" ? 33 : _context2.t0 === "SLASH" ? 34 : _context2.t0 === "MODULO" ? 35 : 36;
                break;

              case 30:
                return _context2.abrupt("return", new TypedValue("int256", left.value.add(right.value)));

              case 31:
                return _context2.abrupt("return", new TypedValue("int256", left.value.sub(right.value)));

              case 32:
                return _context2.abrupt("return", new TypedValue("int256", left.value.mul(right.value)));

              case 33:
                return _context2.abrupt("return", new TypedValue("int256", left.value.pow(right.value)));

              case 34:
                return _context2.abrupt("return", new TypedValue("int256", left.value.div(right.value)));

              case 35:
                return _context2.abrupt("return", new TypedValue("int256", left.value.mod(right.value)));

              case 36:
                this.panic("Undefined binary operator \"".concat(node.operator, "\""));

              case 37:
                if (!("ComparisonExpression" === node.type)) {
                  _context2.next = 55;
                  break;
                }

                _context2.next = 40;
                return this.evaluateNode(node.left);

              case 40:
                _left = _context2.sent;
                _context2.next = 43;
                return this.evaluateNode(node.right);

              case 43:
                _right = _context2.sent;
                leftValue = _left.value, rightValue = _right.value;
                bothTypesAddress = function bothTypesAddress(left, right) {
                  return (// isAddress is true if type is address or bytes with size less than 20
                    _types.default.isAddress(left.type) && _types.default.isAddress(right.type)
                  );
                }, bothTypesBytes = function bothTypesBytes(left, right) {
                  return _types.default.types.bytes.isType(left.type) && _types.default.types.bytes.isType(right.type);
                };
                _context2.t1 = (bothTypesAddress(_left, _right) || bothTypesBytes(_left, _right) ? (leftValue = _ethers.BigNumber.from(leftValue), rightValue = _ethers.BigNumber.from(rightValue)) : (!_types.default.isInteger(_left.type) || !_types.default.isInteger(_right.type)) && this.panic("Cannot evaluate binary expression \"".concat(node.operator, "\" for non-integer or fixed-size bytes types \"").concat(_left.type, "\" and \"").concat(_right.type, "\"")), node.operator);
                _context2.next = _context2.t1 === "GREATER" ? 49 : _context2.t1 === "GREATER_EQUAL" ? 50 : _context2.t1 === "LESS" ? 51 : _context2.t1 === "LESS_EQUAL" ? 52 : _context2.t1 === "EQUAL_EQUAL" ? 53 : _context2.t1 === "BANG_EQUAL" ? 54 : 55;
                break;

              case 49:
                return _context2.abrupt("return", new TypedValue("bool", leftValue.gt(rightValue)));

              case 50:
                return _context2.abrupt("return", new TypedValue("bool", leftValue.gte(rightValue)));

              case 51:
                return _context2.abrupt("return", new TypedValue("bool", leftValue.lt(rightValue)));

              case 52:
                return _context2.abrupt("return", new TypedValue("bool", leftValue.lte(rightValue)));

              case 53:
                return _context2.abrupt("return", new TypedValue("bool", leftValue.eq(rightValue)));

              case 54:
                return _context2.abrupt("return", new TypedValue("bool", !leftValue.eq(rightValue)));

              case 55:
                if (!("TernaryExpression" === node.type)) {
                  _context2.next = 64;
                  break;
                }

                _context2.next = 58;
                return this.evaluateNode(node.predicate);

              case 58:
                if (!_context2.sent.value) {
                  _context2.next = 62;
                  break;
                }

                _context2.t2 = this.evaluateNode(node.left);
                _context2.next = 63;
                break;

              case 62:
                _context2.t2 = this.evaluateNode(node.right);

              case 63:
                return _context2.abrupt("return", _context2.t2);

              case 64:
                if (!("DefaultExpression" === node.type)) {
                  _context2.next = 69;
                  break;
                }

                _context2.next = 67;
                return this.evaluateNode(node.left);

              case 67:
                _left2 = _context2.sent;
                return _context2.abrupt("return", (leftFalsey = _types.default.isInteger(_left2.type) ? _left2.value.isZero() : "address" === _left2.type || _left2.type.startsWith("bytes") ? /^0x[0]*$/.test(_left2.value) : !_left2.value, leftFalsey ? this.evaluateNode(node.right) : _left2));

              case 69:
                if (!("CallExpression" === node.type)) {
                  _context2.next = 94;
                  break;
                }

                if (!("Identifier" === node.target.type && "self" === node.target.value)) {
                  _context2.next = 74;
                  break;
                }

                _context2.t3 = this.to;
                _context2.next = 77;
                break;

              case 74:
                _context2.next = 76;
                return this.evaluateNode(node.target);

              case 76:
                _context2.t3 = _context2.sent;

              case 77:
                target = _context2.t3;
                "bytes20" !== target.type && "address" !== target.type ? this.panic("Target of call expression was not an address") : !_ethers.ethers.utils.isAddress(target.value) && this.panic("Invalid address \"".concat(this.value, "\""));
                _context2.next = 81;
                return this.evaluateNodes(node.inputs);

              case 81:
                inputs = _context2.sent;
                outputs = node.outputs;
                selectedReturnValueIndex = outputs.findIndex(function (output) {
                  return output.selected;
                });
                -1 === selectedReturnValueIndex && this.panic("No selected return value for function call \"".concat(node.callee, "\""));
                returnType = outputs[selectedReturnValueIndex].type;
                abi = [{
                  name: node.callee,
                  type: "function",
                  inputs: inputs.map(function (_ref2) {
                    var type = _ref2.type;
                    return {
                      type: type
                    };
                  }),
                  outputs: outputs.map(function (_ref3) {
                    var type = _ref3.type;
                    return {
                      type: type
                    };
                  }),
                  stateMutability: "view"
                }];
                ethersInterface = new _ethers.ethers.utils.Interface(abi);
                txData = ethersInterface.encodeFunctionData(node.callee, inputs.map(function (input) {
                  return input.value.toString();
                }));
                _context2.next = 91;
                return this.provider.call({
                  to: target.value,
                  data: txData
                });

              case 91:
                data = _context2.sent;
                decodeData = ethersInterface.decodeFunctionResult(node.callee, data);
                return _context2.abrupt("return", new TypedValue(returnType, decodeData[selectedReturnValueIndex]));

              case 94:
                if (!("HelperFunction" === node.type)) {
                  _context2.next = 104;
                  break;
                }

                helperName = node.name;
                this.helpers.exists(helperName) || this.panic("".concat(helperName, " helper function is not defined"));
                _context2.next = 99;
                return this.evaluateNodes(node.inputs);

              case 99:
                _inputs = _context2.sent;
                _context2.next = 102;
                return this.helpers.execute(helperName, _inputs, {
                  provider: this.provider,
                  evaluator: this
                });

              case 102:
                result = _context2.sent;
                return _context2.abrupt("return", new TypedValue(result.type, result.value));

              case 104:
                if (!("PropertyAccessExpression" === node.type && "msg" === node.target.value)) {
                  _context2.next = 112;
                  break;
                }

                if (!("value" === node.property)) {
                  _context2.next = 107;
                  break;
                }

                return _context2.abrupt("return", this.value);

              case 107:
                if (!("sender" === node.property)) {
                  _context2.next = 109;
                  break;
                }

                return _context2.abrupt("return", this.from);

              case 109:
                if (!("data" === node.property)) {
                  _context2.next = 111;
                  break;
                }

                return _context2.abrupt("return", this.data);

              case 111:
                this.panic("Expecting value, sender or data property for msg identifier but got: ".concat(node.property));

              case 112:
                if (!("Identifier" === node.type)) {
                  _context2.next = 118;
                  break;
                }

                if (!("self" === node.value)) {
                  _context2.next = 115;
                  break;
                }

                return _context2.abrupt("return", this.to);

              case 115:
                this.bindings.hasOwnProperty(node.value) || this.panic("Undefined binding \"".concat(node.value, "\""));
                binding = this.bindings[node.value];
                return _context2.abrupt("return", new TypedValue(binding.type, binding.value));

              case 118:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function evaluateNode(_x2) {
        return _evaluateNode.apply(this, arguments);
      }

      return evaluateNode;
    }()
    /**
    * Evaluate the entire AST.
    *
    * @return {string}
    */

  }, {
    key: "evaluate",
    value: function () {
      var _evaluate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.evaluateNodes(this.ast.body).then(function (evaluatedNodes) {
                  return evaluatedNodes.join("");
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function evaluate() {
        return _evaluate.apply(this, arguments);
      }

      return evaluate;
    }()
    /**
    * Report an error and abort evaluation.
    *
    * @param  {string} msg
    */

  }, {
    key: "panic",
    value: function panic(msg) {
      throw new Error("Error: ".concat(msg));
    }
  }]);

  return Evaluator;
}();
/**
* Evaluates an AST
*
* @memberof radspec/evaluator
* @param {radspec/parser/AST} ast The AST to evaluate
* @param {radspec/Bindings} bindings An object of bindings and their values
* @param {?Object} options An options object
* @param {?Object} options.availablehelpers Available helpers
* @param {?ethers.providers.Provider} options.provider EIP 1193 provider
* @param {?string} options.to The destination address for this expression's transaction
* @return {string}
*/


exports.Evaluator = Evaluator;

function evaluate(ast, bindings, options) {
  return new Evaluator(ast, bindings, options).evaluate();
}